import React from "react";
var __jsx = React.createElement;
var FlowOption = function FlowOption(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    id: id,
    className: "outline-none bg-white px-4 py-3 rounded-lg border border-solid border-gray-echo w-full cursor-pointer md:flex-col md:px-2 md:py-4",
    onClick: onClick
  }, children));
};
export default FlowOption;